import { ViewModel,View, ObservableArray } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { IMemberContainer, Method, methodParameters, Property } from "../dataModelBuilder-viewModel";
import { TypeSelectorViewModel } from "../typeSelector/typeSelector-viewModel";
import { MethodBodyManipulatorViewModel } from "./methodBody/methodBodyManipulator/methodBodyManipulator-viewModel";
import  { MethodManipulationView } from "./methodManipulation-view"
import { stringIsNullOrEmpty } from "src/common/utilities";

export class MethodManipulationViewModel extends ViewModel implements IPopup{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.inputParameters = ObservableArray.create<inputParameter>();
        this.returnType = new TypeSelectorViewModel(this,true);
        this.isAsync = false;
        this.methodBodyManipulator = new MethodBodyManipulatorViewModel(this);
    }
    closePopup(result?: any) {
    }
    GetDefaultView(): View <ViewModel> {
        return new MethodManipulationView();
    }
    public getTypeId(): string {
        return "VM-E53EAF84-C7B8-4D15-9B1F-922BC7B48492"
    }

    public set cls(v: IMemberContainer) { this._cls = v; } public get cls(): IMemberContainer { return this._cls;} private _cls: IMemberContainer;
    public set isAsync(v: boolean) { this._isAsync = v; } public get isAsync(): boolean { return this._isAsync;} private _isAsync: boolean;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set inputParameters(v: ObservableArray<inputParameter>) { this._inputParameters = v; } public get inputParameters(): ObservableArray<inputParameter> { return this._inputParameters;} private _inputParameters: ObservableArray<inputParameter>;
    public set returnType(v: TypeSelectorViewModel) { this._returnType = v; } public get returnType(): TypeSelectorViewModel { return this._returnType;} private _returnType: TypeSelectorViewModel;
    public set methodBodyManipulator(v: MethodBodyManipulatorViewModel) { this._methodBodyManipulator = v; } public get methodBodyManipulator(): MethodBodyManipulatorViewModel { return this._methodBodyManipulator;} private _methodBodyManipulator: MethodBodyManipulatorViewModel;
    verify():string[]{
        let result :string[] = [];
        if(stringIsNullOrEmpty(this.name)){
            result.push('Name is not specified.')
        }
        if(this.returnType==null){
            result.push('return type is not specified.')
        }else{
            result.push(...this.returnType.verify());
        }
        this.inputParameters.forEach(x=>{
            if(stringIsNullOrEmpty(x.name)){
                result.push('parameter name is not specified.')
            }
            result.push(...x.type.verify());
        })
        return result;
    }
    confirm(){
        let validatianResult = this.verify();
        if(validatianResult.length>0){
            this.messageBoxConfirmWarning(validatianResult.join('\n'),'Error creating Method')
            return;
        }

        let method = new Method(<any>this.cls)
        method.name = this.name;
        method.isAsync = this.isAsync;
        method.arguments.update(...this.inputParameters.map(x=>{
            let p = new methodParameters(method);
            p.name = x.name;
            p.type = x.type.getSelectedType();
            return p;
        }));
        method.returnType = this.returnType.getSelectedType();
        method.body = this.methodBodyManipulator.serialize();
        this.closePopup(method);
    }
    editMethod(m:Method){
        this.name = m.name;
        this.isAsync = m.isAsync;
        this.returnType.setPropertyType(m.returnType);
        this.inputParameters.update(...m.arguments.map(x=>{
            let r = new inputParameter(this);
            r.name = x.name;
            r.type.setPropertyType(x.type);
            return r;
        }));
        this.methodBodyManipulator.deserialize(m.body);
    }
    
    back(){
        this.closePopup();
    }

    removeArgument(argument:inputParameter){
        this.inputParameters.remove(argument);
    }
    addNewArgument(){
        let a = new inputParameter(this);
        this.inputParameters.push(a);
    }
}

export class inputParameter extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:MethodManipulationViewModel) {
        super(parent);
        this.type = new TypeSelectorViewModel(this);
        this.mehtod = parent;
    }
    public mehtod:MethodManipulationViewModel;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set type(v: TypeSelectorViewModel) { this._type = v; } public get type(): TypeSelectorViewModel { return this._type;} private _type: TypeSelectorViewModel;
    
    remove(){
        this.mehtod.removeArgument(this);
    }
}

